import Comparison from '@/types/comparison';
import { formatMessage } from '@/utils/i18n';
import { timeSince } from '@/utils/time';
import { comparisonIsReadOnly } from '.';

export const getComparisonTimeSinceSave = (comparison: Comparison) => {
  let label;

  // Note : not sure why, but read only comparison seem to have isDirty = true even when they are not.
  if (!comparison.lastRunAt || (comparison.isDirty && !comparisonIsReadOnly(comparison))) {
    label = formatMessage('Comparison.Unsaved');
  } else {
    label = formatMessage('Comparison.TimeSinceSave', { timeSince: timeSince(comparison.lastRunAt, 300000) });
  }

  return label;
};
